import React, { useEffect, useMemo, useRef, useState } from "react";
import { host, Common, Nav as NavApi } from "@Api";
import { useHover, useLocalStorageState, useMount, useSessionStorageState } from "ahooks";
import ArticlePopover from "@Components/newNav/articlePopover";
import MoviePopover from "@Components/newNav/moviePopover";
import { fetchOnline } from "@Services/api";
import { useAtom } from "jotai";
import { initTracking } from "@Lib/jotai/tracking";
import { pkComparisonAtom } from "@Lib/jotai/pkCompare";

const { c } = host;
function activeNav(setActive) {
  const pathname = location.pathname;
  if (/^c\.(.*)8891\.com\.tw$/.test(location.hostname)) {
    if (window.page_route === "newCar:buyCar" || window.page_route === "newCar:buycar") {
      setActive(1);
    } else if (window.page_route === "newCar:Models") {
      setActive(0);
    } else if (window.page_route === "newCar:movies") {
      setActive(3);
    } else if (/^\/photoModel-(ratingCompare|compare).html/.test(pathname)) {
      setActive(4);
    } else if (window.page_route === `newCar:Articles`) {
      setActive(2);
    } else if (["newCar:menu/{brand}", "newCar:menu", "newCar:menu/{brand}/{kind}"].includes(window.page_route)) {
      setActive(6);
    } else if (window.page_route === "newCar:sales/top") {
      setActive(5);
    }
  }
}
const ENFORCE_REQUEST_TIMER = 10000;
let HAS_REQUEST = false;
const SecondaryNav: React.FC<{ defaultActive?: number }> = ({ defaultActive }) => {
  const [active, setActive] = useState(defaultActive || -1);
  const articleRef = useRef<any>(null);
  const movieRef = useRef<any>(null);
  const [onlineData, setOnlineData] = useSessionStorageState<any>("oneline-newcar", {
    defaultValue: { onlineCount: 0, modelCount: 0 },
  });
  const [tracking] = useAtom(initTracking);
  const [isLoaded, setIsLoaded] = useState(false);
  const [articleHovered, updateArticleHovered] = useState(false);
  const [movieHovered, updateMovieHovered] = useState(false);
  const [globalPkList] = useAtom(pkComparisonAtom);

  const isHoveringArticle = useHover(articleRef);
  const isHoveringMovie = useHover(movieRef);

  const getOnlineData = async () => {
    HAS_REQUEST = true;
    const res = await fetchOnline();
    if (res.status === 12000) {
      setOnlineData({ ...res.data });
    }
  };

  const handleExposured = () => {
    if (!tracking) return;
    tracking.trackEvent({
      name: "element_exposured",
      params: {
        page_business: "新車",
        trigger_id: "2483",
        page_id: "620",
        trigger_name: "8891新車",
        next_spm: "3.620.483.1035",
        page: "新車導航",
        channel: "新車",
        element_id: "8891新車",
        element: "按鈕",
        module: "二級導航",
        tracker_method: "config",
      },
    });
    tracking.trackEvent({
      name: "element_exposured",
      params: {
        page_business: "新車",
        trigger_id: "2476",
        page_id: "620",
        trigger_name: "找新車",
        next_spm: "3.620.483.1026",
        page: "新車導航",
        channel: "新車",
        element_id: "找新車",
        element: "按鈕",
        module: "二級導航",
        tracker_method: "config",
      },
    });
    tracking.trackEvent({
      name: "element_exposured",
      params: {
        page_business: "新車",
        trigger_id: "2478",
        page_id: "620",
        trigger_name: "文章",
        next_spm: "3.620.483.1027",
        page: "新車導航",
        channel: "新車",
        element_id: "文章",
        element: "按鈕",
        module: "二級導航",
        tracker_method: "config",
      },
    });
    tracking.trackEvent({
      name: "element_exposured",
      params: {
        page_business: "新車",
        trigger_id: "2480",
        page_id: "620",
        trigger_name: "影音",
        next_spm: "3.620.483.1028",
        page: "新車導航",
        channel: "新車",
        element_id: "影音",
        element: "按鈕",
        module: "二級導航",
        tracker_method: "config",
      },
    });
    tracking.trackEvent({
      name: "element_exposured",
      params: {
        page_business: "新車",
        trigger_id: "2484",
        page_id: "620",
        trigger_name: "比较",
        next_spm: "3.620.483.1029",
        page: "新車導航",
        channel: "新車",
        element_id: "比较",
        element: "按鈕",
        module: "二級導航",
        tracker_method: "config",
      },
    });
    tracking.trackEvent({
      name: "element_exposured",
      params: {
        page_business: "新車",
        trigger_id: "2475",
        page_id: "620",
        trigger_name: "買車頁",
        next_spm: "3.620.483.1025",
        page: "新車導航",
        channel: "新車",
        element_id: "買車頁",
        element: "按鈕",
        module: "二級導航",
        tracker_method: "config",
        expand: "買新車",
      },
    });
    tracking.trackEvent({
      name: "element_exposured",
      params: {
        page_business: "新車",
        trigger_id: "2527",
        page_id: "620",
        trigger_name: "排行榜",
        next_spm: "3.620.483.1069",
        page: "新車導航",
        channel: "新車",
        element_id: "排行榜",
        element: "按鈕",
        module: "二級導航",
        tracker_method: "config",
      },
    });
  };

  useEffect(() => {
    if (isHoveringArticle) {
      updateArticleHovered(true);
    }
    if (isHoveringMovie) {
      updateMovieHovered(true);
    }
  }, [isHoveringArticle, isHoveringMovie]);

  useEffect(() => {
    if (tracking) {
      handleExposured();
    }
  }, [tracking]);

  const handleAfterLoad = () => {
    setIsLoaded(true);
    if (!onlineData?.modelCount) {
      getOnlineData();
    }
  };

  useEffect(() => {
    activeNav(setActive);
    window.addEventListener("load", handleAfterLoad);
    // 保底机制
    setTimeout(() => {
      if (!HAS_REQUEST || !onlineData?.modelCount) {
        getOnlineData();
      }
    }, ENFORCE_REQUEST_TIMER);
    return () => {
      window.removeEventListener("load", handleAfterLoad);
    };
  }, []);

  const isPkCheckedMap = useMemo(() => {
    const checkedList = globalPkList.filter((item: any) => item.isChecked).map((item: any) => item.myid) || [];
    return new Set(checkedList);
  }, [globalPkList]);

  return (
    <div className='w-screen bg-[#fff] max-w-full min-w-1190'>
      <div className='w-1190 relative h-80  mx-auto leading-80 flex justify-between' id='secondaryNav'>
        <div className='flex flex-1 items-center'>
          <a
            href={`${c}`}
            onClick={() => {
              tracking.trackEvent({
                name: "element_clicked",
                params: {
                  page_business: "新車",
                  trigger_id: "2483",
                  page_id: "620",
                  trigger_name: "8891新車",
                  next_spm: "3.620.483.1035",
                  page: "新車導航",
                  channel: "新車",
                  element_id: "8891新車",
                  element: "按鈕",
                  module: "二級導航",
                  tracker_method: "config",
                },
              });
            }}
          >
            <img
              src='https://photo.8891.com.tw/2024/05/21/1716274778529383.png'
              width={148}
              height={32}
              style={{ objectFit: "contain" }}
              alt='8891新車'
            />
          </a>
          <div className='flex justify-start items-center flex-1 ml-36'>
            <a
              id='nav_0'
              className={`text-18 mr-30 block h-32 font-medium cursor-pointer leading-32 hover:text-[#3264FF] ${
                active === 0 ? "text-[#3264FF]" : "text-[#333]"
              }`}
              href={`${c}/Models`}
              target='_blank'
              onClick={() => {
                tracking.trackEvent({
                  name: "element_clicked",
                  params: {
                    page_business: "新車",
                    trigger_id: "2477",
                    page_id: "620",
                    trigger_name: "找新車",
                    next_spm: "3.620.483.1026",
                    page: "新車導航",
                    channel: "新車",
                    element_id: "找新車",
                    element: "按鈕",
                    module: "二級導航",
                    tracker_method: "config",
                  },
                });
              }}
            >
              找汽車
            </a>
            {/* <a
              id='nav_1'
              className={`text-18 mr-30 font-medium block h-32 cursor-pointer leading-32 hover:text-[#3264FF] ${
                active === 1 ? "text-[#3264FF]" : "text-[#333]"
              }`}
              href={`${c}/buyCar`}
              target='_blank'
              onClick={() => {
                tracking.trackEvent({
                  name: "element_clicked",
                  params: {
                    page_business: "新車",
                    trigger_id: "2474",
                    page_id: "620",
                    trigger_name: "買車頁",
                    next_spm: "3.620.483.1025",
                    page: "新車導航",
                    channel: "新車",
                    element_id: "買車頁",
                    element: "按鈕",
                    module: "二級導航",
                    tracker_method: "config",
                    expand: "買新車",
                  },
                });
              }}
            >
              買新車
            </a> */}
            <a
              className={`text-18 mr-30 font-medium block h-32 cursor-pointer leading-32 relative hover:text-[#3264FF] ${
                active === 6 ? "text-[#3264FF]" : "text-[#333]"
              }`}
              href={`${c}/menu`}
              target='_blank'
              onClick={() => {}}
            >
              購車菜單
              <span
                className='w-full h-16 absolute -right-28 -top-12 text-[#fff] text-12 font-normal text-center'
                style={{
                  background: "linear-gradient(180deg,#ff4b40, #ff3030)",
                  borderRadius: "50px 50px 50px 0px",
                  lineHeight: "16px",
                }}
              >
                最新成交價
              </span>
            </a>
            <div ref={articleRef}>
              <a
                id='newTopNav3'
                className={`text-18 mr-30 font-medium  block h-32 cursor-pointer leading-32 hover:text-[#3264FF] ${
                  active === 2 ? "text-[#3264FF]" : "text-[#333]"
                }`}
                href={`${c}/Articles`}
                target='_blank'
                onClick={() => {
                  tracking.trackEvent({
                    name: "element_clicked",
                    params: {
                      page_business: "新車",
                      trigger_id: "2479",
                      page_id: "620",
                      trigger_name: "文章",
                      next_spm: "3.620.483.1027",
                      page: "新車導航",
                      channel: "新車",
                      element_id: "文章",
                      element: "按鈕",
                      module: "二級導航",
                      tracker_method: "config",
                    },
                  });
                }}
              >
                文章
              </a>
              {/* {isLoaded && ( */}
                <div className={`${isHoveringArticle ? "flex" : "none"}`}>
                  {<ArticlePopover isMount={articleHovered} />}
                </div>
              {/* )} */}
            </div>

            <div ref={movieRef}>
              <a
                id='newTopNav4'
                className={`text-18 mr-30 font-medium  block h-32 cursor-pointer leading-32 hover:text-[#3264FF] ${
                  active === 3 ? "text-[#3264FF]" : "text-[#333]"
                }`}
                href={`${c}/movies`}
                target='_blank'
                onClick={() => {
                  tracking.trackEvent({
                    name: "element_clicked",
                    params: {
                      page_business: "新車",
                      trigger_id: "2481",
                      page_id: "620",
                      trigger_name: "影音",
                      next_spm: "3.620.483.1028",
                      page: "新車導航",
                      channel: "新車",
                      element_id: "影音",
                      element: "按鈕",
                      module: "二級導航",
                      tracker_method: "config",
                    },
                  });
                }}
              >
                影音
                {/* {isLoaded && ( */}
                  <div className={`${isHoveringMovie ? "flex" : "hidden"}`}>
                    {<MoviePopover isMount={movieHovered} />}
                  </div>
                {/* )} */}
              </a>
            </div>
            <a
              id='newTopNav5'
              className={`text-18 mr-30 font-medium  block h-32 cursor-pointer leading-32 relative hover:text-[#3264FF] ${
                active === 4 ? "text-[#3264FF]" : "text-[#333]"
              }`}
              href={`${c}/photoModel-compare.html?myids=${Array.from(isPkCheckedMap).join(",")}`}
              target='_blank'
              onClick={() => {
                tracking.trackEvent({
                  name: "element_clicked",
                  params: {
                    page_business: "新車",
                    trigger_id: "2485",
                    page_id: "620",
                    trigger_name: "比较",
                    next_spm: "3.620.483.1029",
                    page: "新車導航",
                    channel: "新車",
                    element_id: "比较",
                    element: "按鈕",
                    module: "二級導航",
                    tracker_method: "config",
                  },
                });
              }}
            >
              比較
              <span
                className='w-22 h-16 absolute -right-4 -top-12 text-[#fff] text-12 font-normal text-center'
                style={{
                  background: "linear-gradient(180deg,#ff4b40, #ff3030)",
                  borderRadius: "50px 50px 50px 0px",
                  lineHeight: "16px",
                }}
              >
                新
              </span>
            </a>
            <a
              id='newTopNav6'
              className={`text-18 mr-30 font-medium  block h-32 cursor-pointer leading-32 hover:text-[#3264FF] ${
                active === 5 ? "text-[#3264FF]" : "text-[#333]"
              }`}
              href={`${c}/sales/top`}
              target='_blank'
              onClick={() => {
                tracking.trackEvent({
                  name: "element_clicked",
                  params: {
                    page_business: "新車",
                    trigger_id: "2528",
                    page_id: "620",
                    trigger_name: "排行榜",
                    next_spm: "3.620.483.1069",
                    page: "新車導航",
                    channel: "新車",
                    element_id: "排行榜",
                    element: "按鈕",
                    module: "二級導航",
                    tracker_method: "config",
                  },
                });
              }}
            >
              排行榜
            </a>
          </div>
        </div>
        <div className='text-[#333] font-medium flex items-center text-14'>
          <span className='text-[#FF0000] text-20'>{onlineData?.onlineCount || 0}</span>人正在找車
        </div>
      </div>
    </div>
  );
};

export default SecondaryNav;
